import React, { useState } from 'react'
import Card from '../../controls/Card';
import Container from '../../base/Container';
import GetAllRegistered from './GetAllRegistered';
import GetTodaysRegistered from './GetTodaysRegistered';
import GetAllConfirmed from './GetAllConfirmed';
import GetTodaysConfirmed from './GetTodaysConfirmed';
import GetAllEmergency from './GetAllEmergency';
import GetTodaysEmergency from './GetTodaysEmergency';
import { MdHistory, MdToday, MdAllInclusive } from 'react-icons/md';
import { FaUserPlus, FaHeartbeat } from 'react-icons/fa';
import { HiOutlineClipboardCheck } from 'react-icons/hi';

export default function OpdRegister() {
    // same values as before:
    // 1 = All Registered, 2 = Today's Registered,
    // 3 = All Confirmed,  4 = Today's Confirmed,
    // 5 = All Emergency,  6 = Today's Emergency
    const [selectedCenterData, setSelectedCenterData] = useState(1);

    const CATEGORIES = [
        { key: "registered", label: "Registered", Icon: FaUserPlus, all: 1, today: 2, active: "bg-blue-500 text-white shadow" },
        { key: "confirmed", label: "Confirmed", Icon: HiOutlineClipboardCheck, all: 3, today: 4, active: "bg-green-500 text-white shadow" },
        { key: "emergency", label: "Emergency", Icon: FaHeartbeat, all: 5, today: 6, active: "bg-red-500 text-white shadow" },
    ]

    const current = CATEGORIES.find(c => c.all == selectedCenterData || c.today == selectedCenterData)
    const isToday = current.today == selectedCenterData

    const PERIODS = [
        { key: "all", label: "All", Icon: MdAllInclusive },
        { key: "today", label: "Today", Icon: MdToday },
    ]

    return (
        <Container title={"Opd History"}>
            <div className="w-full px-2 sm:px-4">
                <Card
                    isBorder={true}
                    isUser={true}
                    title={
                        <div className="flex w-full items-center gap-2">
                            <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-brand-500 text-white shadow-sm">
                                <MdHistory className="text-base" />
                            </span>
                            <div className="min-w-0 leading-tight">
                                <span className="block truncate">Opd History</span>
                                <span className="block truncate text-xs font-normal text-gray-500">
                                    {isToday ? "Today's" : "All"} {current.label.toLowerCase()} patients
                                </span>
                            </div>
                        </div>
                    }
                >
                    <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                        {/* category tabs */}
                        <div className="flex gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1 md:shrink-0">
                            {CATEGORIES.map(({ key, label, Icon, all, today, active }) => {
                                const isCurrent = current.key == key
                                return (
                                    <button
                                        key={key}
                                        type="button"
                                        aria-pressed={isCurrent}
                                        onClick={() => setSelectedCenterData(isToday ? today : all)}
                                        className={`flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm ${isCurrent ? active : "text-gray-500 hover:bg-white hover:text-gray-700"}`}
                                    >
                                        <Icon className="text-sm sm:text-base" />
                                        {label}
                                    </button>
                                )
                            })}
                        </div>

                        {/* All / Today toggle */}
                        <div className="flex gap-1 self-start rounded-xl bg-gray-100 p-1 md:self-auto">
                            {PERIODS.map(({ key, label, Icon }) => {
                                const isCurrent = key == "today" ? isToday : !isToday
                                return (
                                    <button
                                        key={key}
                                        type="button"
                                        aria-pressed={isCurrent}
                                        onClick={() => setSelectedCenterData(key == "today" ? current.today : current.all)}
                                        className={`flex items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold transition sm:text-sm ${isCurrent ? "bg-brand-500 text-white shadow" : "text-gray-500 hover:bg-white hover:text-gray-700"}`}
                                    >
                                        <Icon className="text-sm sm:text-base" />
                                        {label}
                                    </button>
                                )
                            })}
                        </div>
                    </div>

                    {/* content */}
                    <div className="mt-3">
                        {selectedCenterData == 1 && <GetAllRegistered />}
                        {selectedCenterData == 2 && <GetTodaysRegistered />}
                        {selectedCenterData == 3 && <GetAllConfirmed />}
                        {selectedCenterData == 4 && <GetTodaysConfirmed />}
                        {selectedCenterData == 5 && <GetAllEmergency />}
                        {selectedCenterData == 6 && <GetTodaysEmergency />}
                    </div>
                </Card>
            </div>
        </Container>
    )
}